import { ActionType, getType } from 'typesafe-actions';
import { RequestState } from '../../constants/request-state';
import { LoanFieldValuesState } from '../../types/state/entities/LoanFieldValuesState';
import { loanFieldValuesActions } from '../../actions/entities/loanFieldValues.actions';

export const loanFieldValuesDefaultState: LoanFieldValuesState = {
    requestState: RequestState.none,
    values: {
        issuers: [],
        industries: [],
        facilities: [],
        useOfProceeds: [],
        refIndexes: [],
        arrangers: [],
        coArrangers: [],
        draftArrangers: [],
        draftCoArrangers: [],
        passingReasons: [],
    },
};

export type LoanFieldValuesActionTypes = ActionType<typeof loanFieldValuesActions[keyof typeof loanFieldValuesActions]>;

export function loanFieldValuesReducer(
    state = loanFieldValuesDefaultState,
    action: LoanFieldValuesActionTypes,
): LoanFieldValuesState {
    switch (action.type) {
        case getType(loanFieldValuesActions.request):
            return { ...state, requestState: action.payload.requestState };
        case getType(loanFieldValuesActions.response):
            return { requestState: action.payload.requestState, values: action.payload.values };
        case getType(loanFieldValuesActions.reset):
            return loanFieldValuesDefaultState;
        default:
            return state;
    }
}
